import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getSpeakers } from '../utils/services';
import speakersMock from '../mocks/speakers';

const { Consumer, Provider } = React.createContext();

const SpeakersProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [speakers, setSpeakers] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState('');
  const SPEAKERS = speakersMock;

  const loadSpeakers = async () => {
    setIsLoading(true);
    // const loadedSpeakers = await getSpeakers();
    const loadedSpeakers = SPEAKERS;
    setSpeakers(loadedSpeakers);
    setIsLoading(false);
  };

  return (
    <Provider
      value={{
        isLoading,
        selectedSpeaker,
        speakers,
        loadSpeakers,
        setSelectedSpeaker
      }}>
      {children}
    </Provider>
  );
};

SpeakersProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { SpeakersProvider, Consumer as SpeakersConsumer };
